/*
  Flowkeeper - Pomodoro timer for power users and teams
  Copyright (c) 2023 Constantine Kulak, Geoffrey Espagne

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation; either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/

import React from 'react';
import {Route, Routes} from 'react-router-dom';
import MainPage from './components/pages/MainPage';
import SignInPage from './components/pages/SignInPage';
import './App.css';
import {GoogleOAuthProvider} from '@react-oauth/google';
import {TooManyRequestsBanner} from './components/misc/TooManyRequestsBanner'

import {connection} from "./fk/core/websocket_event_source";

import {initEventSourceFromCookies} from "./fk/core/websocket_event_source";

import DataContext from './components/context/DataContext';
import ConnectionContext from './components/context/ConnectionContext';

import {Root} from './fk/core/root';

function App() {
    // Those variables are only for updating React UI
    const [dataForUi, setDataForUi] = React.useState<Root | null>(null);
    const [conn, setConnection] = React.useState(connection);

    // TODO: Embed those settings, together with the server port, during build time
    const clientId: string = "248052959881-pqd62jj04427c7amt7g72crmu591rip8.apps.googleusercontent.com";

    let isFirstLoad = true;

    React.useEffect(() => {
        if(!dataForUi || !dataForUi.isLoggedIn && isFirstLoad) {
            initEventSourceFromCookies(setDataForUi, setConnection);
        }
        isFirstLoad = false;
    }, [dataForUi]);

    return (
        <GoogleOAuthProvider clientId={clientId}>
            <ConnectionContext.Provider value={{connection: conn, setConnection: setConnection}}>
                <DataContext.Provider value={{data: dataForUi, setData: setDataForUi}}>
                    <TooManyRequestsBanner/>
                    <Routes>
                        <Route path='/' element={ <MainPage/> } />
                        <Route path='/login' element={ <SignInPage /> } />
                    </Routes>
                </DataContext.Provider>
            </ConnectionContext.Provider>
        </GoogleOAuthProvider>
    )
}

export default App;